import React, { useState, useEffect } from "react";
import Header from "../../components/Headers/Header";
import { CSVLink } from "react-csv";
import {
  Container,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Row,
  Col,
  Input,
  Spinner,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { getLicenses } from "store/actions/playerActions";
import { getSignUpPayments } from "store/actions/playerActions";
import { adminMonthlyEarningsByYear } from "store/actions/additionalEarningAction";
import TabsInfoModal from "components/Modal/TabsInfoModal";

function DashboardBusiness() {
  let dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [byYear, setByYear] = useState(new Date().getFullYear());
  const currentYear = new Date().getFullYear();
  const startYear = 2022;
  const endYear = 2030;
  const years = [];
  const infoPoints = [
    "Admin overview the total earning from the platform monthwise as well as annually.",
  ];
  const subPoints = [];
  const infoTitle = "Dashboard Buisness Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  for (let year = endYear; year >= startYear; year--) {
    years.push(year);
  }

  let { adminMonthlyEarnings } = useSelector((state) => state.earnings);
  useEffect(() => {
    setLoader(true);
    dispatch(
      adminMonthlyEarningsByYear(byYear, () => {
        setLoader(false);
      })
    );
  }, [byYear]);

  const handlePrint = (divPrint) => {
    var printContents = document.getElementById(divPrint).innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  const headers = [
    { label: "Month", key: "month" },
    { label: "Price", key: "earnings" },
  ];

  return (
    <>
      <Header />
      <Container fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <Card className="mb-5">
          <CardHeader>
            <Row>
              <Col xs={12} md={6}>
                <CardTitle>Fans Help Players</CardTitle>
                <CardSubtitle>USA</CardSubtitle>
              </Col>
              <Col xs={12} md={6} className="text-md-end mt-3 mt-md-0">
                <div className="d-flex flex-column flex-sm-row justify-content-md-end">
                  <CSVLink
                    filename="Monthly_Sales.csv"
                    headers={headers}
                    data={adminMonthlyEarnings.map((item) => {
                      return {
                        ...item,
                      };
                    })}
                    className="w-100 w-sm-50 w-lg-auto mb-2 mb-sm-0 mr-sm-2"
                  >
                    <Button color="primary" className="btn-primary w-100">
                      Download
                    </Button>
                  </CSVLink>
                  <Button
                    color="primary"
                    className="btn btn-primary w-100 w-sm-50 w-lg-auto"
                    onClick={() => handlePrint("divToPrint")}
                  >
                    Print
                  </Button>
                </div>
              </Col>
            </Row>
          </CardHeader>

          <div id="divToPrint">
            <CardBody>
              <Row className="no-gutters">
                <Col md="10" xs="8">
                  <p className="custom-filter-heading mb-sm-0">By Month</p>
                </Col>
                <Col md="2" xs="4">
                  <p className="custom-filter-heading ml-auto mb-sm-0 text-right">
                    By Year
                  </p>
                </Col>
              </Row>
              <Row className="no-gutters">
                <Col lg="10" md="9" xs="8">
                  {loader ? (
                    <div className="text-center">
                      <Spinner />
                    </div>
                  ) : (
                    <Row>
                      {adminMonthlyEarnings?.map((sale, index) => {
                        return (
                          <Col
                            lg="2"
                            md="4"
                            sm="4"
                            xs="6"
                            className="mt-3"
                            key={index}
                          >
                            <CardSubtitle className="text-dark-1">
                              {sale.month}
                            </CardSubtitle>
                            <CardSubtitle className="mt-2">
                              ${sale.earnings.toFixed(2)}
                            </CardSubtitle>
                          </Col>
                        );
                      })}
                    </Row>
                  )}
                </Col>
                <Col lg="2" md="3" xs="4" className="mt-3">
                  <CardSubtitle className="text-right text-primary">
                    <Input
                      type="select"
                      value={byYear}
                      onChange={(e) => setByYear(e.target.value)}
                    >
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </Input>
                  </CardSubtitle>
                </Col>
              </Row>
            </CardBody>
          </div>
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
}

export default DashboardBusiness;
